module.exports = __webpack_public_path__ + "media/images/xpass/icons/brands/inactive/clubpilates-f1cba33a104f8590c4535bf61c5bf432.png";